<template>
  <div>
    <SummaryEvent v-if="summary" :event="event" />

    <DetailEvent v-else :event="event" />
  </div>
</template>

<script>
import DeclinedEvent from '@/components/requests/leave/events/DeclinedEvent'
import SummaryEvent from '@/components/requests/leave/timeline/SummaryEvent'
import DetailEvent from '@/components/requests/leave/timeline/DetailEvent'

export default {
  name: 'LeaveWasRejected',

  components: { DetailEvent, SummaryEvent },

  props: {
    event: {
      type: DeclinedEvent,
      required: true,
    },

    summary: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
